'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.monthsFromNow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/monthsFromNow.js
// module id = 722
// module chunks = 0